import { connect } from 'react-redux';
import AuthPage from 'js/pages/auth';
export default connect(function (state, ownProps) {
  var plan;
  if (ownProps.match.params.plan) plan = ownProps.match.params.plan;
  return {
    isMobileWidth: state.device.isMobileWidth,
    view: ownProps.view,
    plan: plan
  };
})(AuthPage);